/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationResponseBaseResponse as ModelsV3ApplicationApplicationResponseBaseResponse } from '../../models/Models/v3/Application/application-response-base-response';
import { ApplicationStartRequest as ModelsV3ApplicationApplicationStartRequest } from '../../models/Models/v3/Application/application-start-request';

export interface V3ApplicationVehiclePost$Json$Plain$Params {
      body?: ModelsV3ApplicationApplicationStartRequest
}

export function v3ApplicationVehiclePost$Json$Plain(http: HttpClient, rootUrl: string, params?: V3ApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationVehiclePost$Json$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationResponseBaseResponse>;
    })
  );
}

v3ApplicationVehiclePost$Json$Plain.PATH = '/v3/application/vehicle';
